import React, { useEffect } from "react"; 
import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchMenu } from "../features/menu/menuSlice";
import gridSvg from "../assets/svg/grid.svg";
import settingsSvg from "../assets/svg/svg49.svg";
import usersSvg from "../assets/svg/usersSvg.svg";
import payrollSvg from "../assets/svg/svg50.svg";
import leaveSvg from "../assets/svg/svg54.svg";
import transactionSvg from "../assets/svg/svg55.svg";
import adminSvg from "../assets/svg/admin.svg";
import paymentSvg from "../assets/svg/paymentSvg.svg";
import reportSvg from "../assets/svg/svg58.svg";
import casualSvg from "../assets/svg/svg61.svg";
import shiftSvg from "../assets/svg/shiftSvg.svg";
import storeItemSvg from "../assets/svg/svg75.svg";
import { useNavigate } from "react-router-dom";

const menuData = [
  {
    mnId: "1",
    mnLink: "dashboard-main",
    mnName: "dashboard",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: null,
    children: [],
  },

  {
    mnId: "2",
    mnLink: null,
    mnName: "Personnel",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "usersSvg",
    children: [
      {
        mnId: "22",
        mnLink: "group",
        mnName: "Employees",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "23",
        mnLink: "organogram",
        mnName: "Organogram",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "22",
        mnLink: "attendance-entries",
        mnName: "Attendance Entries",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },

      {
        mnId: "22",
        mnLink: "attendance-map",
        mnName: "Attendance Map",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
      
    ],
  },
  {
    mnId: "7",
    mnLink: null,
    mnName: "Casuals Management",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "casualSvg",
    children: [
      // {
      //   mnId: "71",
      //   mnLink: "casual-types",
      //   mnName: "Casual Types",
      //   mnOwner: "ALL",
      //   mnParentId: "2",
      //   mnIcons: null,
      //   children: [],
      // },
      {
        mnId: "72",
        mnLink: "casual-profile",
        mnName: "Casual Listings",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "73",
        mnLink: "casual-attendance",
        mnName: "Casual Attendance",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
    ],
  },
  {
    mnId: "5",
    mnLink: null,
    mnName: "Leave Management",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "leaveSvg",
    children: [
      {
        mnId: "51",
        mnLink: "leave-types",
        mnName: "Leave Types",
        mnOwner: "ALL",
        mnParentId: "5",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "52",
        mnLink: "leave-days",
        mnName: "Leave Days",
        mnOwner: "ALL",
        mnParentId: "5",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "52",
        mnLink: "leave-schedule",
        mnName: "Leave Schedule",
        mnOwner: "ALL",
        mnParentId: "5",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "53",
        mnLink: "leave-appplications",
        mnName: "Leave Applications",
        mnOwner: "ALL",
        mnParentId: "5",
        mnIcons: null,
        children: [],
      },
    ],
  },

  {
    mnId: "12",
    mnLink: null,
    mnName: "Shift Management",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "shiftSvg",
    children: [
      {
        mnId: "121",
        mnLink: "shift-type",
        mnName: "Shift Type",
        mnOwner: "ALL",
        mnParentId: "12",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "122",
        mnLink: "shift-schedule",
        mnName: "Shift Schedule",
        mnOwner: "ALL",
        mnParentId: "12",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "123",
        mnLink: "shift-request",
        mnName: "Shift Approval",
        mnOwner: "ALL",
        mnParentId: "12",
        mnIcons: null,
        children: [],
      },
    ],
  },

  {
    mnId: "6",
    mnLink: null,
    mnName: "Transactions",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "transactionSvg",
    children: [
      {
        mnId: "61",
        mnLink: "staff-banks",
        mnName: "Staff Banks",
        mnOwner: "ALL",
        mnParentId: "6",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "62",
        mnLink: "staff-exempts",
        mnName: "Staff Exempts",
        mnOwner: "ALL",
        mnParentId: "6",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "63",
        mnLink: "wef-entries",
        mnName: "W.E.F",
        mnOwner: "ALL",
        mnParentId: "6",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "63",
        mnLink: "staff-transactions",
        mnName: "Staff Transactions",
        mnOwner: "ALL",
        mnParentId: "6",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "64",
        mnLink: "payslip-messages",
        mnName: "Payslip Messages",
        mnOwner: "ALL",
        mnParentId: "6",
        mnIcons: null,
        children: [],
      },
    ],
  },
  // {
  //   mnId: "9",
  //   mnLink: null,
  //   mnName: "Payments",
  //   mnOwner: "ALL",
  //   mnParentId: null,
  //   mnIcons: "paymentSvg",
  //   children: [
  //     {
  //       mnId: "91",
  //       mnLink: "ndovu-pay",
  //       mnName: "Wallet",
  //       mnOwner: "ALL",
  //       mnParentId: "9",
  //       mnIcons: null,
  //       children: [],
  //     },
  //     {
  //       mnId: "92",
  //       mnLink: "direct-payment",
  //       mnName: "Direct Payment",
  //       mnOwner: "ALL",
  //       mnParentId: "9",
  //       mnIcons: null,
  //       children: [],
  //     },
  //     {
  //       mnId: "93",
  //       mnLink: "payroll-payments",
  //       mnName: "Payroll Payments",
  //       mnOwner: "ALL",
  //       mnParentId: "9",
  //       mnIcons: null,
  //       children: [],
  //     },
  //     {
  //       mnId: "94",
  //       mnLink: "casual-payments",
  //       mnName: "Casual Payments",
  //       mnOwner: "ALL",
  //       mnParentId: "9",
  //       mnIcons: null,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   mnId: "11",
  //   mnLink: null,
  //   mnName: "Assets",
  //   mnOwner: "ALL",
  //   mnParentId: null,
  //   mnIcons: "storeItemSvg",
  //   children: [
  //     {
  //       mnId: "111",
  //       mnLink: "store-items",
  //       mnName: "Store Items",
  //       mnOwner: "ALL",
  //       mnParentId: "11",
  //       mnIcons: null,
  //       children: [],
  //     },
  //     {
  //       mnId: "112",
  //       mnLink: "fixed-assets",
  //       mnName: "Fixed Assets",
  //       mnOwner: "ALL",
  //       mnParentId: "11",
  //       mnIcons: null,
  //       children: [],
  //     },
  //     {
  //       mnId: "113",
  //       mnLink: "store-request",
  //       mnName: "Store Request",
  //       mnOwner: "ALL",
  //       mnParentId: "11",
  //       mnIcons: null,
  //       children: [],
  //     },
  //     {
  //       mnId: "114",
  //       mnLink: "asset-transfer",
  //       mnName: "Asset Transfer",
  //       mnOwner: "ALL",
  //       mnParentId: "11",
  //       mnIcons: null,
  //       children: [],
  //     },
      
      
  //   ],
  // },
  {
    mnId: "8",
    mnLink: null,
    mnName: "Admin",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "adminSvg",
    children: [
      {
        mnId: "81",
        mnLink: "users-list",
        mnName: "Users",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "82",
        mnLink: "audit-trail",
        mnName: "Audit Trail",
        mnOwner: "ALL",
        mnParentId: "2",
        mnIcons: null,
        children: [],
      },
    ],
  },

 
  {
    mnId: "3",
    mnLink: null,
    mnName: "Setups",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "settingsSvg",
    children: [
      {
        mnId: "31",
        mnLink: "company-branch",
        mnName: "Company Branches",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "32",
        mnLink: "company-department",
        mnName: "Company Departments",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "33",
        mnLink: "company-section",
        mnName: "Company Sections",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "35",
        mnLink: "staff-grade",
        mnName: "Staff Grade",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "36",
        mnLink: "staff-position",
        mnName: "Staff Position",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "37",
        mnLink: "enagement-terms",
        mnName: "Engagement Terms",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "37",
        mnLink: "staff-category",
        mnName: "Staff Category",
        mnOwner: "ALL",
        mnParentId: "3",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "22",
        mnLink: "payroll-type",
        mnName: "Payroll Types",
        mnOwner: "ALL",
        mnParentId: "4",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "23",
        mnLink: "fiscal-year",
        mnName: "Fiscal Years",
        mnOwner: "ALL",
        mnParentId: "4",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "24",
        mnLink: "fiscal-period",
        mnName: "Fiscal Periods",
        mnOwner: "ALL",
        mnParentId: "4",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "24",
        mnLink: "bank",
        mnName: "Banks",
        mnOwner: "ALL",
        mnParentId: "4",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "24",
        mnLink: "bank-branch",
        mnName: "Bank Branches",
        mnOwner: "ALL",
        mnParentId: "4",
        mnIcons: null,
        children: [],
      },
      {
        mnId: "25",
        mnLink: "payroll-item",
        mnName: "Payroll Items",
        mnOwner: "ALL",
        mnParentId: "4",
        mnIcons: null,
        children: [],
      },
      // {
      //   mnId: "34",
      //   mnLink: "staff-status",
      //   mnName: "Staff Status",
      //   mnOwner: "ALL",
      //   mnParentId: "3",
      //   mnIcons: null,
      //   children: [],
      // },
      // {
      //   mnId: "24",
      //   mnLink: "payslip-headers",
      //   mnName: "Payslip Headers",
      //   mnOwner: "ALL",
      //   mnParentId: "4",
      //   mnIcons: null,
      //   children: [],
      // },
      // {
      //   mnId: "26",
      //   mnLink: "payroll-formula",
      //   mnName: "Formulas",
      //   mnOwner: "ALL",
      //   mnParentId: "4",
      //   mnIcons: null,
      //   children: [],
      // },
      // {
      //   mnId: "26",
      //   mnLink: "tax-rate",
      //   mnName: "Tax Rates ",
      //   mnOwner: "ALL",
      //   mnParentId: "4",
      //   mnIcons: null,
      //   children: [],
      // },
      // {
      //   mnId: "26",
      //   mnLink: "nhif-rate",
      //   mnName: "Nhif Rates ",
      //   mnOwner: "ALL",
      //   mnParentId: "4",
      //   mnIcons: null,
      //   children: [],
      // },
    ],
  },

  {
    mnId: "10",
    mnLink: null,
    mnName: "Reports",
    mnOwner: "ALL",
    mnParentId: null,
    mnIcons: "reportSvg",
    children: [
      {
        mnId: "101",
        mnLink: "main-reports",
        mnName: "Main Reports",
        mnOwner: "ALL",
        mnParentId: "10",
        mnIcons: null,
        children: [],
      },
    ],
  },
  
   
];

const icons = {
  gridSvg,
  usersSvg,
  settingsSvg,
  payrollSvg,
  leaveSvg,
  transactionSvg,
  adminSvg,
  paymentSvg,
  reportSvg,
  casualSvg,
  shiftSvg,
  storeItemSvg
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
 
export default function SideBarClosed() {
  const { sideMenuCollapsed } = useSelector((state) => state.global); 
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        const iconSrc = icons[item?.mnIcons] || gridSvg;
        return getItem(
          item?.mnName.charAt(0).toUpperCase() + item?.mnName.slice(1),
          item?.mnLink,
          !isChild ? <img src={iconSrc} alt={item?.mnIcons} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }
   
    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const handleNavigation = async (e) => {
    await navigate(e?.key);
  };
  useEffect(() => {}, [sideMenuCollapsed]);

 
  return (
    <>
      <div
        style={{
          borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        }}
        className="flex flex-col h-full bg-[#f4f5f7]"
      >
        <Menu
          onClick={handleNavigation}
          defaultSelectedKeys={["dash", "/dashboard"]}
          defaultOpenKeys={[]}
          mode="inline"
          theme="light"
          inlineCollapsed={sideMenuCollapsed} 
          items={items}
        />
      </div>
    </>
  );
}
